import { Controller, useFormContext } from 'react-hook-form';

import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import { useDataProvider, useLocalization } from '@ui-framework/index';
import MultiValueSelector from './MultiValueSelector';
import rulesFormatter from '../utils/rulesFormatter';

const MultiValueSelectorController = forwardRef((props, ref) => {
  const { control } = useFormContext();
  const { formatMessage } = useLocalization();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);
  const { field } = props;

  return (
    <Box ref={ref}>
      <Controller
        name={props?.name}
        control={control}
        render={({ field: controllerField }) => {
          return (
            <MultiValueSelector
              title={formatMessage({
                id: field.label.localeId,
                defaultMessage: field.label.defaultMessage,
              })}
              value={controllerField?.value}
              onChange={data => {
                controllerField.onChange(data);
              }}
              valueFormatter={rulesFormatter}
              leftNameKey={field?.leftNameKey}
              leftValueKey={field?.leftValueKey}
              rightValueKey={field?.rightValueKey}
              limit={10}
              getLeftItemsUrl={`${getApiUrl()}${field.api}`}
              leftTitle={formatMessage({
                id: field.label.localeId,
                defaultMessage: field.label.defaultMessage,
              })}
            />
          );
        }}
      />
    </Box>
  );
});

export default MultiValueSelectorController;
